<template>
  <el-table
    :data="data.history"
    :default-sort="{ prop: 'regDate', order: 'descending' }"
    style="width: 100%"
  >
    <el-table-column
      prop="regDate"
      label="변경일시"
      width="160"
      align="center"
    />
    <el-table-column
      prop="actionType"
      label="수행자"
      width="240"
    />
    <el-table-column
      label="변경 내용"
    >
      <template #default="scope">
        {{ getLogMessageValue(scope.row.logType) }}
        <span v-if="scope.row.logType === 'CREATED_EAGLE_PLAN' || scope.row.logType === 'CREATED_EAGLE_PV' || scope.row.logType === 'CREATED_EAGLE_JAM' || scope.row.logType === 'COMPLETED_PAYMENT_CARD'">
          <el-button
            text
            aria-label="이미지 보기"
            @click="openImageViewer(scope.row.image)"
            >
            <font-awesome-icon icon="fa-regular fa-image" />
          </el-button>
        </span>
        <span 
          v-if="scope.row.logType === 'COMPLETED_PAYMENT_WIRE'|| scope.row.logType === 'COMPLETED_PAYMENT_WIRE_DELAY'"
          class="log-red"
        >
          (입금일: {{  scope.row.actualPaymentDate }})
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup lang='ts'>
import { defineProps, defineEmits } from 'vue';
import { RequestInfo } from '@/types/Request';
import { getLogMessageValue }  from '@/utils/getValueForKey';

defineProps<{
  data: RequestInfo;
}>();

const emits = defineEmits<{
  (event: 'open-image-viewer', image: string): void;
}>();

const openImageViewer = (image: string) => {
  emits('open-image-viewer', image);
};

</script>